<div class="row">
    <form [formGroup]="frmCreatedByFollow">
        <mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
            <mat-expansion-panel-header class="disable_ripple">
                <mat-panel-title>
                    <div *ngIf="this.frmCreatedByFollow.errors?.['required']==null">
                        <b>CREATED BY & UPDATED BY </b>
						<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_CreatedByUpdatedBy_Overview'"></help-text-btn>
                    </div>
                    <div *ngIf="this.frmCreatedByFollow.errors?.['required']">
                        <b style="color: red;">CREATED BY & UPDATED BY (incomplete)</b>
                    </div>


                </mat-panel-title>

            </mat-expansion-panel-header>

            <div class="row">
                <span><b>Created by:</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_CreatedByUpdatedBy_CreatedBy'"></help-text-btn>
				</span>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">                
                    <mat-form-field>
                        <mat-label>First Name</mat-label>
                        <input matInput type="string" placeholder="First Name" formControlName="fName"
                            (focusout)="updateChangeValue()" />
                    </mat-form-field>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <mat-form-field>
                        <mat-label>Last Name</mat-label>
                        <input matInput type="string" placeholder="Last Name" formControlName="lName"
                            (focusout)="updateChangeValue()" />
                    </mat-form-field>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <mat-form-field>
                        <mat-label>MM/DD/YY</mat-label>
                        <input matInput type="string" placeholder="MM/DD/YY" formControlName="createdDate"
                            (focusout)="updateChangeValue()" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row" *ngIf="inaStatusTypeId==2">
                <b>Updated by:</b>
            </div>

            <div class="row" *ngIf="inaStatusTypeId==2">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <mat-form-field>
                        <mat-label>First Name</mat-label>
                        <input matInput type="string" placeholder="First Name" formControlName="updatedFName"
                            (focusout)="updateChangeValue()" />
                    </mat-form-field>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <mat-form-field>
                        <mat-label>Last Name</mat-label>
                        <input matInput type="string" placeholder="Last Name" formControlName="updatedLName"
                            (focusout)="updateChangeValue()" />
                    </mat-form-field>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <mat-form-field>
                        <mat-label>MM/DD/YY</mat-label>
                        <input matInput type="string" placeholder="MM/DD/YY" formControlName="updatedCreatedDate"
                            (focusout)="updateChangeValue()" />
                    </mat-form-field>
                </div>
            </div>


            <div class="row" *ngIf="updatedFName.invalid || updatedFName.invalid || updatedCreatedDate.invalid">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <button mat-flat-button color="primary" (click)="populateNameDate()">Add name and date</button>
                </div>
            </div>

            <div class="row" *ngIf="updatedFName.valid && updatedLName.valid && updatedCreatedDate.valid">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <button mat-flat-button color="warn" (click)="clearNameDate()">Clear</button>
                </div>
            </div>








            <div class="row" style="padding-top: 30px" *ngIf="(action==2 || action==3) ">
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Past Edit - {{this.trackHistories.inaHistory.length}}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngIf="this.trackHistories.inaHistory.length>=1">
                            <app-past-edit [section]="this.section"></app-past-edit>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </mat-expansion-panel>
    </form>
</div>

<div class="row" style="padding-top: 30px">
    <div>
        <mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
            <mat-expansion-panel-header class="disable_ripple">
                <mat-panel-title>
                    <b> OPTIONAL COMMENTS </b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OptionalComments_Overview'"></help-text-btn>
                </mat-panel-title>
                <mat-panel-description>

                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="row">
                <div *ngIf="editing && this.action!=3">
                    <button mat-raised-button color="primary" class="button-add-row" (click)="addRow('Comments')"
                        [disabled]="this.getQuestions('Comments').length>19">
                        Add Comments
                    </button>
                </div>
            </div>
            <div class="row">
                <app-table-edit-comment [(listQuestion)]="commentEditableQuestions" [editing]="editing"
                    (modificationEvent)="OperationCUD($event)" [type]="'Comments'" [action]="this.action">
                </app-table-edit-comment>
            </div>
        </mat-expansion-panel>
    </div>
</div>